import {Text} from 'platform/foundation';
import {useFormatCurrency} from 'platform/locale';

import {Money} from '@dms/api/shared';
import i18n from '@dms/i18n';

export const PlatformPrice = ({price}: {price: Money | null}) => {
  const formatCurrency = useFormatCurrency();

  return price ? (
    <div>{formatCurrency(parseFloat(price.amount), price.currency)}</div>
  ) : (
    <Text size="xSmall" color="danger">
      {i18n.t('general.notifications.noValue')}
    </Text>
  );
};
